export type Currency = Nullable<{
  value: number
  currency: PropsTypesOf<typeof CurrencyTypeEnum>['code']
}>

function load(model?: Partial<Currency> | null): Currency {
  return {
    value: model?.value ?? null,
    currency: model?.currency ?? CurrencyTypeEnum.DominicanPeso.code,
  }
}

export const CurrencyTypeEnum = {
  DominicanPeso: { label: 'Pesos', acronyme: 'RD', code: 'DominicanPeso' },
  UnitedStatesDollar: { label: 'Dolares', acronyme: 'USD', code: 'UnitedStatesDollar' },
} as const

function getCurrencyTypeList() {
  return Object.values(CurrencyTypeEnum)
}

function getCurrencyAcronyme(code: Currency['currency']) {
  return code ? CurrencyTypeEnum[code].acronyme : ''
}

export const Currency = {
  load,
  getCurrencyTypeList,
  getCurrencyAcronyme,
}
